//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'ViewerMirador',
  components: {},
  data() {
      return {}
  },
  props: {
    configs: {
      type: Object,
      default: function () {return {}}
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
  },
  created() {
    this.src = `#/components/mirador/${encodeURIComponent(JSON.stringify(this.configs))}`;
  },
  mounted() {

  },
  watch: {},
  computed: {},
  methods: {},
}
